import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  items: [],
  totalItems: 0,
  totalPrice: 0,
  loading: false,
  error: null
};

const cartSlice = createSlice({
  name: 'cart',
  initialState,
  reducers: {
    fetchCartStart(state) {
      state.loading = true;
      state.error = null;
    },
    fetchCartSuccess(state, action) {
      state.items = action.payload.items || [];
      state.totalItems = action.payload.totalItems || 0;
      state.totalPrice = action.payload.totalPrice || 0;
      state.loading = false;
    },
    fetchCartFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    addToCartSuccess(state, action) {
      const updatedItem = action.payload;
      const existingIndex = state.items.findIndex(
        item => item?.productId === updatedItem?.productId && 
               item?.variantId === updatedItem?.variantId
      );
      
      if (existingIndex >= 0) {
        state.items[existingIndex] = updatedItem;
      } else {
        state.items.push(updatedItem);
      }
      
      // Recalculate totals
      state.totalItems = state.items.reduce((sum, item) => sum + item.quantity, 0);
      state.totalPrice = state.items.reduce((sum, item) => sum + item.total, 0);
    },
    removeFromCartSuccess(state, action) {
      const { productId, variantId } = action.payload;
      state.items = state.items.filter(
        item => !(item.productId === productId && 
                 (variantId ? item.variantId === variantId : true))
      );
      
      // Recalculate totals
      state.totalItems = state.items.reduce((sum, item) => sum + item.quantity, 0);
      state.totalPrice = state.items.reduce((sum, item) => sum + item.total, 0);
    },
    clearCartSuccess(state) {
      state.items = [];
      state.totalItems = 0;
      state.totalPrice = 0;
    },
    updateCartItemQuantity(state, action) {
      const { productId, variantId, quantity } = action.payload;
      const item = state.items.find(
        item => item.productId === productId && 
               (variantId ? item.variantId === variantId : true)
      );
      
      if (item) {
        item.quantity = quantity;
        item.total = item.price * quantity;
        
        // Recalculate totals
        state.totalItems = state.items.reduce((sum, item) => sum + item.quantity, 0);
        state.totalPrice = state.items.reduce((sum, item) => sum + item.total, 0);
      }
    }
  }
});

export const {
  fetchCartStart,
  fetchCartSuccess,
  fetchCartFailure,
  addToCartSuccess,
  removeFromCartSuccess,
  clearCartSuccess,
  updateCartItemQuantity
} = cartSlice.actions;

export default cartSlice.reducer;

// import { createSlice } from '@reduxjs/toolkit';
// const initialState = {
//   items: [],
//   totalItems: 0,
//   totalPrice: 0,
//   loading: false,
//   error: null
// };

// const cartSlice = createSlice({
//   name: 'cart',
//   initialState,
//   reducers: {
//     fetchCartStart(state) {
//       state.loading = true;
//       state.error = null;
//     },
//     fetchCartSuccess(state, action) {
//       state.items = action.payload.items || [];
//       state.totalItems = action.payload.totalItems || 0;
//       state.totalPrice = action.payload.totalPrice || 0;
//       state.loading = false;
//     },
//     fetchCartFailure(state, action) {
//       state.loading = false;
//       state.error = action.payload;
//     },
//     addToCartSuccess(state, action) {
//       const updatedItem = action.payload;
//       console.log("payload",action.payload)
//             console.log("state", state.items)

//       const existingIndex = state.items.findIndex(
//         item => item?.productId === updatedItem?._id
//       );
      
//       if (existingIndex >= 0) {
//         state.items[existingIndex] = updatedItem;
//       } else {
//         state.items.push(updatedItem);
//       }
      
//       // Recalculate totals
//       state.totalItems = state.items.reduce((sum, item) => sum + item.quantity, 0);
//       state.totalPrice = state.items.reduce((sum, item) => sum + item.total, 0);
//     },
//     removeFromCartSuccess(state, action) {
//       const productId = action.payload;
//       state.items = state.items.filter(item => item.productId !== productId);
      
//       // Recalculate totals
//       state.totalItems = state.items.reduce((sum, item) => sum + item.quantity, 0);
//       state.totalPrice = state.items.reduce((sum, item) => sum + item.total, 0);
//     },
//     clearCartSuccess(state) {
//       state.items = [];
//       state.totalItems = 0;
//       state.totalPrice = 0;
//     },
//     updateCartItemQuantity(state, action) {
//       const { productId, quantity } = action.payload;
//       console.log("update cart item quantity inside cart slice product id", productId)
//             console.log("update cart item quantity inside cart slice quantity", quantity)

//       const item = state.items.find(item => item.productId === productId);
//       if (item) {
//         item.quantity = quantity;
//         item.total = item.price * quantity;
        
//         // Recalculate totals
//         state.totalItems = state.items.reduce((sum, item) => sum + item.quantity, 0);
//         state.totalPrice = state.items.reduce((sum, item) => sum + item.total, 0);
//       }
//     }
//   }
// });

// export const {
//   fetchCartStart,
//   fetchCartSuccess,
//   fetchCartFailure,
//   addToCartSuccess,
//   removeFromCartSuccess,
//   clearCartSuccess,
//   updateCartItemQuantity
// } = cartSlice.actions;

// export default cartSlice.reducer;

// import { createSlice } from '@reduxjs/toolkit';

// const initialState = {
//   items: [],
// };

// const cartSlice = createSlice({
//   name: 'cart',
//   initialState,
//   reducers: {
//     setCartItems: (state, action) => {
//       state.items = action.payload;
//     },
//     addToCart: (state, action) => {
//       const newItem = action.payload;
//       const existingItem = state.items.find(item => item.id === newItem.id);
//       if (existingItem) {
//         existingItem.quantity += newItem.quantity;
//       } else {
//         state.items.push(newItem);
//       }
//     },
//     removeFromCart: (state, action) => {
//       state.items = state.items.filter(item => item.id !== action.payload);
//     },
//     updateQuantity: (state, action) => {
//       const { id, quantity } = action.payload;
//       const item = state.items.find(item => item.id === id);
//       if (item) {
//         item.quantity = Math.max(1, quantity);
//       }
//     },
//     clearCart: (state) => {
//       state.items = [];
//     },
//   },
// });

// export const { setCartItems, addToCart, removeFromCart, updateQuantity, clearCart } = cartSlice.actions;
// export default cartSlice.reducer;


// import { createSlice } from '@reduxjs/toolkit';

// const initialState = {
//   items: [],
// };

// const cartSlice = createSlice({
//   name: 'cart',
//   initialState,
//   reducers: {
//     addToCart: (state, action) => {
//       const newItem = action.payload;
//       const existingItem = state.items.find(item => item.id === newItem.id);
      
//       if (existingItem) {
//         existingItem.quantity += newItem.quantity;
//       } else {
//         state.items.push(newItem);
//       }
//     },
//     removeFromCart: (state, action) => {
//       state.items = state.items.filter(item => item.id !== action.payload);
//     },
//     updateQuantity: (state, action) => {
//       const { id, quantity } = action.payload;
//       const item = state.items.find(item => item.id === id);
      
//       if (item) {
//         item.quantity = Math.max(1, quantity); // Ensure minimum quantity is 1
//       }
//     },
//     clearCart: (state) => {
//       state.items = [];
//     },
//   },
// });

// export const { addToCart, removeFromCart, updateQuantity, clearCart } = cartSlice.actions;
// export default cartSlice.reducer;

// // src/redux/slices/cartSlice.js
// import { createSlice } from '@reduxjs/toolkit';

// const initialState = {
//   items: [], // { id, name, price, quantity }
// };

// const cartSlice = createSlice({
//   name: 'cart',
//   initialState,
//   reducers: {
//     addToCart: (state, action) => {
//       const item = action.payload;
//       const existingItem = state.items.find((i) => i.id === item.id);
//       if (existingItem) {
//         existingItem.quantity += item.quantity;
//       } else {
//         state.items.push(item);
//       }
//     },
//     removeFromCart: (state, action) => {
//       state.items = state.items.filter((item) => item.id !== action.payload);
//     },
//     updateQuantity: (state, action) => {
//       const { id, quantity } = action.payload;
//       const item = state.items.find((i) => i.id === id);
//       if (item) {
//         item.quantity = quantity;
//       }
//     },
//     clearCart: (state) => {
//       state.items = [];
//     },
//   },
// });

// export const { addToCart, removeFromCart, updateQuantity, clearCart } = cartSlice.actions;
// export default cartSlice.reducer;
